var map = {
	"./1.png": 9988,
	"./10.png": 1774,
	"./11.png": 7559,
	"./12.png": 524,
	"./13.png": 2149,
	"./14.png": 90,
	"./15.png": 9923,
	"./16.png": 7944,
	"./17.png": 6337,
	"./18.png": 1206,
	"./19.png": 5007,
	"./2.png": 4639,
	"./20.png": 3887,
	"./21.png": 4870,
	"./3.png": 8310,
	"./4.png": 8137,
	"./5.png": 3312,
	"./6.png": 1643,
	"./7.png": 7426,
	"./8.png": 6581,
	"./9.png": 7484
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7050;